// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import AppLogoImg from '../Utils/AppLogoImg';

const AppDeletionError = (appsParam) => {

  useEffect(() => {        
    console.log("Pantalla mensaje de error")
  },[appsParam.deletionConflictDevices]);

  function obtenerNombreDispositivo(idDispositivo){
    if(idDispositivo === "MainElectricConnectionSensor"){return "Sensor acometida principal"}
    if(idDispositivo === "MainFVSensor"){return "Sensor FV"}
    if(idDispositivo === "BatteriesSensor"){return "Sensor baterías"}
    if(idDispositivo === "BatteriesTemperatureSensor"){return "Sensor temperatura baterías"}
    if(idDispositivo === "GeneratorOnOffSwitch"){return "Interruptor encendido/apagado"}
    if(idDispositivo === "GeneratorP1Sensor"){return "Sensor fase 1"}
    if(idDispositivo === "GeneratorP2Sensor"){return "Sensor fase 2"}
    if(idDispositivo === "GeneratorP3Sensor"){return "Sensor fase 3"}
    if(idDispositivo === "CarID"){return "Coche"}
  }

  function obtenerModuloDispositivo(idModulo){
    if(idModulo === "GeneralInfo"){return "Configuración general"}
    if(idModulo === "FV"){return "Paneles solares"}
    if(idModulo === "Battery"){return "Baterías"}
    if(idModulo === "Generator"){return "Grupo electrógeno"}
    if(idModulo === "Cars"){return "Coche"}
  }

  function redirigirPaginaConfiguracion(device){

    if(localStorage.getItem("installationConfigurationMode") === null){
      window.location.href="/InitialConfig/"+device.split("|")[0]
    }
    else{
      window.location.href="/InstallationConfiguration/"+device.split("|")[0]
    }

  }

  const ConflictElementsList = (componentParam) => {    

    if(componentParam.deletionConflictDevices.length > 0){
      const listApps = componentParam.deletionConflictDevices.map((device) =>
      <li key={device.split("|")[1]}>  
        <button className="forward icon-wrapper" onClick={() => redirigirPaginaConfiguracion(device)}>
          <figure className="avatar size-m"><AppLogoImg aplicacion={appsParam.AppName}/></figure>
          <div className="content">
            <h1 className="brand-name">{obtenerNombreDispositivo(device.split("|")[1])}</h1>
            <p className="size-s">Ir a {obtenerModuloDispositivo(device.split("|")[0])}</p>
          </div>
        </button>                
      </li> 
      );    
      return (
        <ul>{listApps}</ul>
      )
    }
    else{      
      return (
        <p>No existen dispositivos conflictivos o se produjo un error al recuperarlos.</p>
      );
    }
  }



  return (          
    <>
          <header>
            <figure className="avatar size-m orange"><span className="material-icon">cable</span></figure>
            <h1 className="headline-03">Eliminar {appsParam.AppName}</h1>
          </header>

          <section className="brands">

            <div className="message error left">
              <h1 className="title"><span className="material-icon">error</span>No se puede eliminar la aplicación</h1>
              <p>Tienes componentes básicos de tu instalación que la usan</p>
            </div>

            <p>Para eliminar la aplicación debes modificar la configuración que se indica abajo por otra aplicación/dispositivos o borrar el bloque de configuración (Ej: Baterías) que genera conflicto. Una vez realizado ya podrás eliminar esta aplicación sin problema.</p>
            <p>Los dispositivos {appsParam.AppName} que están generando conflicto actualmente son:</p>

            <section className="brands-list">  
              <ConflictElementsList deletionConflictDevices={appsParam.deletionConflictDevices} />
            </section>                          
          </section>
    </> 
  )
}

export default AppDeletionError